import React from 'react';

import ResponsiveVimeoVideo from './responsiveVimeoVideo';

function MissionFutureSchoolVideoMF2026({ translations }) {
  const videoUrl = translations?.videoUrl;
  const title = translations?.title;

  if (!videoUrl) {
    return null;
  }

  return (
    <section className="bg-swiss-100 py-10 md:py-14">
      <div className="container mx-auto max-w-5xl px-4 md:px-6">
        {title ? (
          <h2
            className="text-2xl md:text-3xl font-extrabold text-[#333333] text-center mb-8 md:mb-10"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        ) : null}
        <div className="max-w-4xl mx-auto rounded-2xl overflow-hidden">
          <ResponsiveVimeoVideo url={videoUrl} />
        </div>
      </div>
    </section>
  );
}

export { MissionFutureSchoolVideoMF2026 };
